import { nfts } from '@/assets'

export const mockUser = {
  walletAddress: '7EYnhQoR9YM3N7UoaKRoA44Uy8JeaZV3qyouov87awMs',
  username: 'CryptoPythian',
  nft: {
    name: 'Pythenian #1234',
    image: nfts.pythia, // Using actual Pythia NFT image
    collection: 'Pythenians',
    collectionAddress: '60f7f69070dfc98235f75832de1c5aee571a5b34c266169c21f47763ffb742ca',
    mintAddress: 'ExampleMintAddress123',
    attributes: [
      { trait_type: 'Background', value: 'Purple Nebula' },
      { trait_type: 'Body', value: 'Python' },
      { trait_type: 'Eyes', value: 'Laser' },
      { trait_type: 'Accessory', value: 'Oracle Crown' }
    ]
  },
  linkedAccounts: {
    discord: {
      linked: true,
      username: 'CryptoPythian#1234',
      userId: '123456789012345678',
      roles: ['1234567890', '0987654321'], // Mock role IDs from Pyth server
      linkedAt: '2024-01-15T10:30:00Z'
    },
    twitter: {
      linked: true,
      handle: 'cryptopythian',
      userId: '987654321',
      linkedAt: '2024-01-15T10:45:00Z'
    }
  },
  scores: {
    discord: 3000,
    twitter: 1000,
    pythGovernance: 4500,
    jupStaking: 1800,
    kmnoStaking: 1200
  },
  totalScore: 15125,
  rank: 42,
  totalUsers: 3000,
  badges: ['Oracle', 'Early Adopter', 'Governance Voter', 'Staker'],
  isAdmin: true,
  joinedAt: '2024-01-15T10:00:00Z',
  lastUpdated: '2024-01-20T15:30:00Z'
}

// Mock user without NFT (for testing gate)
export const mockUserNoNFT = {
  walletAddress: '8FkNhRoS9ZN4O8VpbLSpB55Vz9KfbZW4rzpvpw98bxNt',
  username: null,
  nft: null,
  linkedAccounts: {
    discord: { linked: false },
    twitter: { linked: false }
  },
  scores: null,
  totalScore: 0,
  rank: null,
  totalUsers: 0,
  badges: []
}
